import { motion } from "framer-motion";
import { CAPABILITIES } from "../../data/content";

const STATS = [
  { n: "7-PLY", l: "Max board strength" },
  { n: "ISPM-15", l: "Export certified" },
  { n: "100%", l: "Custom engineered" }
];

export const Capabilities = () => {
  return (
    <section
      id="capabilities"
      data-testid="capabilities-section"
      className="relative bg-background py-24 md:py-32 border-t border-border scroll-mt-16"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="mb-16 md:mb-20 max-w-3xl">
          <p className="font-mono-ibm text-xs tracking-widest uppercase text-primary mb-4">
            / Capabilities
          </p>
          <h2 className="font-display uppercase leading-[0.88] tracking-tight text-5xl md:text-7xl">
            Certified. Tested.
            <br />
            <span className="text-primary">Delivered.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border border border-border mb-px">
          {STATS.map((s) => (
            <div key={s.n} className="bg-background p-8 md:p-10">
              <p className="font-display text-5xl md:text-7xl tracking-tight text-foreground">
                {s.n}
              </p>
              <p className="font-mono-ibm text-xs tracking-widest uppercase text-muted-foreground mt-2">
                {s.l}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border border border-border">
          {CAPABILITIES.map((c, i) => (
            <motion.div
              key={c.k}
              data-testid={`capability-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className="group bg-background p-8 md:p-10 hover:bg-secondary/40 transition-colors"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="w-2 h-2 bg-primary group-hover:scale-150 transition-transform" />
                <h3 className="font-display uppercase tracking-tight text-xl md:text-2xl">
                  {c.k}
                </h3>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">{c.v}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
